export default __webpack_public_path__ + "static/media/l5-p4.50d4975d.png";